import React from "react";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { uploadUserProfileImage } from "../../../store/auth/actions";
import { toastr } from "react-redux-toastr";
import { vaildFileExtension } from "../../../utils/files";

type Props = {
  uploadUserProfileImage: (file: File) => any;
};

const PictureReader = (props: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files != null) {
      const file = event.target.files[0];
      const MAX_FILENAME_LENGTH = 100;
      if(!file) {
        toastr.error(
          "Alert", "No file selected. Please choose a file to upload."
        );
        return;
      }
      if(!file.name) {
        toastr.error(
          "Alert", "The file name is invalid. Please choose a file with a valid name."
        );
        return;
      }
      if (file.name.length > MAX_FILENAME_LENGTH) {
        toastr.error(
          "Alert", "The file name exceeds 100 characters. Please rename the file and try again."
        );
        return;
      }

      const allowedExtensions = ["jpg", "jpeg", "png"];

      const extension = file.name.split(".").pop()?.toLowerCase();
      if (!extension || !allowedExtensions.includes(extension)) {
        toastr.error(
          "Alert", "This file format is not supported. Upload a JPG, JPEG, or PNG image."
        );
        return;
      }
      if(!vaildFileExtension(file)) {
        return;
      }
      const fileSizeInBytes = file?.size;
      const fileSizeInMB = fileSizeInBytes / (1024 * 1024); // Convert bytes to MB
  
      if (fileSizeInMB > 1) {
        toastr.error("Alert", "The image size exceeds 1 MB. Please choose an image smaller than 1 MB.");
        return; // Exit the function if the file size exceeds the limit
      }
      props.uploadUserProfileImage(file);
    }
  };

  return (
    <input
      style={{ display: "none" }}
      type="file"
      accept={"image/*"}
      onChange={handleChange}
    />
  );
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      uploadUserProfileImage: uploadUserProfileImage,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(PictureReader);
